import { App } from "antd";
import { useCallback } from "react";
import { useFolderTree } from "@devowl-wp/react-folder-tree";
import { toggleSortable } from "../../../backbone/attachmentSortable.js";
import { useAppTreeControllerRef } from "../../../contexts/appTreeControllerContext.js";
import { useAppTreeLocalState } from "../../../contexts/appTreeLocalStateContext.js";
import { useAppTreeMountContext } from "../../../contexts/appTreeMountContext.js";
import { rmlOpts } from "../../../utils/rmlOpts.js";
function useOrderHandlers() {
    const { message } = App.useApp();
    const { set } = useFolderTree();
    const controllerRef = useAppTreeControllerRef();
    const { attachmentsBrowser } = useAppTreeMountContext();
    const { setIsMoveable, setIsWPAttachmentsSortMode, setShowProFeature } = useAppTreeLocalState();
    const handleOrderClick = useCallback(()=>{
        if (!rmlOpts.others.isPro && rmlOpts.others.showProHints) {
            setShowProFeature("order-content");
        } else {
            const node = controllerRef.current.getTreeItemById();
            if (toggleSortable(node, true, attachmentsBrowser, message)) {
                setIsMoveable(false);
                setIsWPAttachmentsSortMode(true);
                set({
                    toolbarActiveButton: "order"
                });
            }
        }
    }, [
        attachmentsBrowser,
        controllerRef,
        message,
        set,
        setIsMoveable,
        setIsWPAttachmentsSortMode,
        setShowProFeature
    ]);
    const handleOrderCancel = useCallback(()=>{
        toggleSortable(controllerRef.current.getTreeItemById(), false, attachmentsBrowser, message);
        setIsMoveable(true);
        setIsWPAttachmentsSortMode(false);
        set({
            toolbarActiveButton: undefined
        });
    }, [
        attachmentsBrowser,
        controllerRef,
        message,
        set,
        setIsMoveable,
        setIsWPAttachmentsSortMode
    ]);
    return {
        handleOrderClick,
        handleOrderCancel
    };
}
export { useOrderHandlers };
